import IPButton from '../../../../../components/IPButton'
import { useMemo, useState } from 'react'
import '../../AccountSummary/AccountSummary.scss'
import Swal from 'sweetalert2'
import InputCampaign from '../../../../../components/InputCampaign'
import { exportToXLSXVDFMultipleColumns, formatCurrencyTemlik } from '../../../../../base/utils/dataHelper'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPExcelButton from '../../../../../components/IPExcelButton'
import Table from '../../../../../components/Table'
import { GetUrunFiyatFarkiRequest, GetUrunFiyatFarkiResponse } from '../models/model'
import { GetUrunFiyatFarkiApi } from '../services/getUrunFiyatFarkiApi'
import { URUN_FIYAT_FARKI_INVOICE_SOURCE } from '../services/getUrunFiyatFarkiInvoiceApi'
import moment from 'moment'

const formatSapDate = (value?: string) => (value ? moment(value, 'YYYYMMDD').format('DD.MM.YYYY') : '')

function VodafoneUrunFiyatFarki(props: BaseComponentWithContextProps) {
  const [data, setData] = useState<GetUrunFiyatFarkiResponse[]>([])
  const [imei, setImei] = useState<string>('')
  const [startDate, setStartDate] = useState<string>(moment().startOf('month').format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState<string>(moment().format('YYYY-MM-DD'))
  const [currentPage, setCurrentPage] = useState(0)

  const getList = async () => {
    if (!startDate || !endDate) {
      return Swal.fire({
        icon: 'error',
        title: 'Kayıt başlangıç ve bitiş tarihi zorunludur.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }

    if (moment(startDate).isAfter(moment(endDate))) {
      return Swal.fire({
        icon: 'error',
        title: 'Başlangıç tarihi bitiş tarihinden büyük olamaz.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }

    // Bayi kodu backend tarafında oturumdan eklenir.
    const req: GetUrunFiyatFarkiRequest = {
      StartDate: moment(startDate).format('YYYYMMDD'),
      EndDate: moment(endDate).format('YYYYMMDD'),
      Imei: imei.trim(),
    }

    props.showLoading()
    const api: GetUrunFiyatFarkiApi = new GetUrunFiyatFarkiApi({})

    api
      .getList(req)
      .then(result => {
        props.hideLoading()
        setCurrentPage(0)
        setData(result ?? [])
        if (!result || result.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Ürün fiyat farkı verisi bulunamadı',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
      .catch((err: any) => {
        props.hideLoading()
        Swal.fire({
          icon: 'error',
          title: err?.description ?? 'Ürün fiyat farkı verisi alınırken hata oluştu.',
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      })
  }

  const tableColumns = useMemo(
    () => [
      { Header: 'Cari Kod', accessor: 'cariKod' },
      { Header: 'Şube Kodu', accessor: 'subeKodu' },
      { Header: 'IMEI', accessor: 'imei' },
      { Header: 'BAYİ ALIŞ FATURASI', accessor: 'satisFaturasi' },
      { Header: 'AKTİVASYON TUTAR', accessor: 'aktivasyonTutar' },
      { Header: 'TEMLİK TUTAR', accessor: 'temlikTutar' },
      { Header: 'FİYAT FARKI', accessor: 'fiyatFarki' },
      { Header: 'KAYIT TARİHİ', accessor: 'kayitTarihi' },
      { Header: 'FATURA NOTU', accessor: 'faturaNotu' },
      { Header: 'MALİYET DÜZELTME FATURASI', accessor: 'referans' },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      data.map(item => ({
        cariKod: item.CARI_KOD,
        subeKodu: item.SUBE_KODU,
        imei: item.IMEI,
        // Satış faturası (DGT, VBRK-XBLNR) bayiye ait olup olmadığı kontrol edilerek ayrı uçtan açılır.
        satisFaturasi: item.SATIS_FATURASI ? (
          <a
            href={`/myspecial/EInvoice?eInvoiceId=${item.SATIS_FATURASI}&date=${item.SATIS_FATURA_YILI}&source=${URUN_FIYAT_FARKI_INVOICE_SOURCE}`}
            target='_blank'
            rel='noreferrer'
            title='Fatura için tıklayınız!'
          >
            {item.SATIS_FATURASI}
          </a>
        ) : (
          ''
        ),
        aktivasyonTutar: <div style={{ textAlign: 'right' }}>{formatCurrencyTemlik(item.AKTIVASYON_TUTAR)}</div>,
        temlikTutar: <div style={{ textAlign: 'right' }}>{formatCurrencyTemlik(item.TEMLIK_TUTAR)}</div>,
        fiyatFarki: <div style={{ textAlign: 'right' }}>{formatCurrencyTemlik(item.FIYAT_FARKI)}</div>,
        kayitTarihi: formatSapDate(item.KAYIT_TARIHI),
        faturaNotu: item.FATURA_NOTU,
        // Referans (BKPF.XBLNR) e-fatura numarasıdır; Siparişlerim'deki gibi e-faturayı yeni sekmede açar.
        referans: item.REFERANS ? (
          <a
            href={`/myspecial/EInvoice?eInvoiceId=${item.REFERANS}&date=${item.FATURA_YILI}`}
            target='_blank'
            rel='noreferrer'
            title='Fatura için tıklayınız!'
          >
            {item.REFERANS}
          </a>
        ) : (
          ''
        ),
      })),
    [data]
  )

  const excelButton = async () => {
    try {
      if (!data || data.length === 0) {
        return Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
      }

      // Tutar sütunları E, F, G; exportToXLSXVDFMultipleColumns bunları sayıya çevirir.
      const excelData: any[] = data.map(item => ({
        'Cari Kod': item.CARI_KOD,
        'Şube Kodu': item.SUBE_KODU,
        IMEI: item.IMEI,
        'BAYİ ALIŞ FATURASI': item.SATIS_FATURASI,
        'AKTİVASYON TUTAR': formatCurrencyTemlik(item.AKTIVASYON_TUTAR),
        'TEMLİK TUTAR': formatCurrencyTemlik(item.TEMLIK_TUTAR),
        'FİYAT FARKI': formatCurrencyTemlik(item.FIYAT_FARKI),
        'KAYIT TARİHİ': formatSapDate(item.KAYIT_TARIHI),
        'FATURA NOTU': item.FATURA_NOTU,
        'MALİYET DÜZELTME FATURASI': item.REFERANS,
      }))

      exportToXLSXVDFMultipleColumns(excelData, 'Ürün Fiyat Farkları', 'E,F,G')
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description ?? 'Excel aktarımında hata oluştu.',
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  return (
    <div className='Reports'>
      <div className='heading-text d-flex justify-content-between align-items-center'>
        <h4 style={{ textAlign: 'center' }}>Maliyet Düzeltme</h4>
        <div className='d-flex align-items-center'>
          <IPExcelButton onClick={excelButton} />
        </div>
      </div>

      <form>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='StartDate'
              name='StartDate'
              label='Kayıt Başlangıç Tarihi'
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='EndDate'
              name='EndDate'
              label='Kayıt Bitiş Tarihi'
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='Imei'
              name='Imei'
              label='IMEI'
              value={imei}
              onChange={e => setImei(e.target.value)}
              isActive
            />
          </div>
        </div>

        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-3' style={{ justifyContent: 'center', display: 'flex' }}>
            <IPButton
              text='Listele'
              className='button'
              onClick={() => getList()}
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '10px',
                width: '150px',
                height: '50px',
              }}
            />
          </div>
        </div>
      </form>

      <div className='m-4'>
        <Table
          columns={tableColumns}
          data={tableData}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          columnCount={10}
          backgroundColor='red'
          color='white'
        />
      </div>
    </div>
  )
}

export default componentWithContext(VodafoneUrunFiyatFarki)
